
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceDetail from './components/ServiceDetail';
import ServiceProcess from './components/ServiceProcess';
import ServiceArea from './components/ServiceArea';
import ServiceCTA from './components/ServiceCTA';

export default function Services() {
  useEffect(() => {
    // Update page title and meta tags
    document.title = '岡山市・倉敷市のリフォーム工事｜住宅・店舗・修繕専門｜おかやまリフォーム株式会社';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '岡山市・倉敷市でリフォーム工事をお考えなら25年の実績を持つおかやまリフォーム株式会社へ。住宅リフォーム、店舗工事、修繕工事まで幅広く対応。無料見積もり・現地調査実施中。岡山県内全域対応可能。');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'リフォーム工事,岡山市,倉敷市,住宅リフォーム,店舗工事,修繕工事');
    }

    // Add canonical URL
    const canonical = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`);
    if (!document.querySelector('link[rel="canonical"]')) {
      document.head.appendChild(canonical);
    }

    // Schema.org JSON-LD for Service page
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "リフォーム工事サービス",
      "description": "岡山市・倉敷市を中心とした住宅リフォーム、店舗工事、修繕工事の専門サービス",
      "provider": {
        "@type": "LocalBusiness",
        "name": "おかやまリフォーム株式会社",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "○○町1-2-3",
          "addressLocality": "岡山市北区",
          "addressRegion": "岡山県",
          "postalCode": "700-0000",
          "addressCountry": "JP"
        },
        "telephone": "086-012-3456"
      },
      "serviceType": ["住宅リフォーム", "店舗工事", "修繕工事"],
      "areaServed": ["岡山市", "倉敷市", "岡山県"],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "リフォーム工事サービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "住宅リフォーム",
              "description": "キッチン、バスルーム、内装など住宅全般のリフォーム工事"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "店舗工事",
              "description": "飲食店、美容室、オフィスなどの店舗新装・改装工事"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "修繕工事",
              "description": "雨漏り修理、外壁補修、屋根工事などの建物修繕"
            }
          }
        ]
      }
    };

    // Add schema to head
    const existingScript = document.getElementById('service-schema');
    if (existingScript) {
      existingScript.remove();
    }
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'service-schema';
    script.textContent = JSON.stringify(serviceSchema);
    document.head.appendChild(script);

    return () => {
      const serviceScript = document.getElementById('service-schema');
      if (serviceScript) serviceScript.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ServiceHero />
        <ServiceDetail />
        <ServiceProcess />
        <ServiceArea />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
